import React from 'react';
import { Link } from 'react-router-dom';
import { FaMapMarkerAlt } from 'react-icons/fa';
import Classes from './AreaGroups.module.css';
import { AREA_GROUPS } from '../../../data/serviceAreas';

// One card per county with its cities as arrow rows (same layout as quickvents.com).
export default function AreaGroups() {
    return (
        <div className={Classes.grid}>
            {AREA_GROUPS.map((g) => (
                <div key={g.county} className={Classes.panel}>
                    <div className={Classes.head}>
                        <span className={Classes.pin} aria-hidden="true"><FaMapMarkerAlt /></span>
                        <h3>{g.county}</h3>
                    </div>
                    <ul className={Classes.list}>
                        {g.areas.map((a) => (
                            <li key={a.slug}>
                                <Link to={`/service-areas/${a.slug}`}>
                                    {a.city}
                                    <span aria-hidden="true">→</span>
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>
            ))}
        </div>
    );
}
